import React from "react";
import ConfirmDialog from "../../components/Base/ConfirmDialog";
import { updateSolanaStatus } from "../../request/config";
import { alertSuccess } from "../../store/actions/alert";
import { useDispatch } from "react-redux";

const EnableShowWinnerParticipantForm = (props: any) => {
  const {
    isOpenEditPopupShowWinnerParticipant,
    setIsOpenEditPopupShowWinnerParticipant,
    disableButton,
    fetchFlags,
    showWinnerParticipantFlag,
    showWinnerParticipantFeatFlag,
    setShowWinnerParticipantFeatFlag,
    displayShowWinnerParticipantLabel,
    localShowWinnerParticipantFlag,
  } = props;
  const dispatch = useDispatch();

  const handleSubmitPopup = async () => {
    const name = showWinnerParticipantFlag?.name;
    try {
      const response = await updateSolanaStatus(
        { name, value: localShowWinnerParticipantFlag },
        showWinnerParticipantFlag?.id
      );

      fetchFlags();
      dispatch(alertSuccess("Successfull"));
      setIsOpenEditPopupShowWinnerParticipant(false);
      setShowWinnerParticipantFeatFlag(response.data.value);
    } catch (e) {
      console.log(e, "error");
    }
  };

  const handleCancel = () => {
    setIsOpenEditPopupShowWinnerParticipant(false);
    setShowWinnerParticipantFeatFlag(showWinnerParticipantFeatFlag);
  };
  return (
    <ConfirmDialog
      title={
        displayShowWinnerParticipantLabel ? "Enable Show Winner & Participant" : "Disable Show Winner & Participant"
      }
      open={isOpenEditPopupShowWinnerParticipant}
      confirmLoading={disableButton}
      onConfirm={handleSubmitPopup}
      onCancel={handleCancel}
    >
      <div>Are you sure you want to {localShowWinnerParticipantFlag ? "enable" : "disable"} Show Winner & Participant?</div>
    </ConfirmDialog>
  );
};

export default EnableShowWinnerParticipantForm;
